<template>
  <el-dialog
    v-if="valuteInModal"
    :title="valuteInModal._id ? 'Редактировать валюту' : 'Добавить валюту'"
    :visible.sync="computedDialogVisible"
    :before-close="CancelEditValuteWithConfirm"
    custom-class="valute-dialog"
  >
    <el-form
      ref="valuteInModal"
      :model="valuteInModal"
      label-width="150px"
      size="small"
    >
      <div class="inline-form-row">
        <el-form-item
          label="Название"
          prop="title"
          :rules="validation.title.rules"
          label-width="145px"
        >
          <el-input v-model="valuteInModal.title"></el-input>
        </el-form-item>
        <el-form-item
          label="Ключ валюты"
          prop="key"
          :rules="validation.key.rules"
          label-width="145px"
        >
          <el-input v-model="valuteInModal.key"></el-input>
        </el-form-item>
        <el-form-item
          label="Категории"
          prop="categories"
          :rules="validation.categories.rules"
          label-width="125px"
        >
          <el-select
            v-model="valuteInModal.categories"
            placeholder="Категории"
            class="full-width-field"
            multiple
            clearable
          >
            <el-option
              v-for="item in categories"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="BestChange ключ" label-width="145px">
          <el-input v-model="valuteInModal.bestchangeKey"></el-input>
        </el-form-item>
        <!--  -->
        <el-form-item
          label="Подтверждения сети"
          class="long-label"
          label-width="145px"
        >
          <el-input-number
            v-model="valuteInModal.confirmations"
            title="Подтверждения сети"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="Округление" label-width="145px">
          <el-popover
            placement="top"
            title=""
            width="300"
            trigger="hover"
            content="Если 0 и более - округлять знаки после запятой, если меньше 0 - округлять до десятков, сотен и т.д. Например при значении 2 и введенном числе 0,123 - округлит до 0,12. При значении 2 и введенном числе 123456 - округлит до 123500."
          >
            <i slot="reference" class="el-icon-info"></i>
          </el-popover>
          <el-input-number
            v-model="valuteInModal.precision"
            :min="-8"
            title="Кол-во знаков после запятой"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="Депозитность" label-width="115px">
          <el-switch v-model="valuteInModal.depositable" disabled></el-switch>
        </el-form-item>
        <el-form-item label="Выводимость" label-width="110px">
          <el-switch v-model="valuteInModal.withdrawable" disabled></el-switch>
        </el-form-item>
      </div>
      <div class="inline-form-row">
        <el-form-item label="Покупаем" label-width="115px">
          <el-switch v-model="valuteInModal.isGive"></el-switch>
        </el-form-item>
        <el-form-item label="Предупреждение при покупке" class="long-label">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-model="valuteInModal.giveWarn"
          ></el-input>
        </el-form-item>
      </div>
      <div class="inline-form-row">
        <el-form-item label="Продаем" label-width="115px">
          <el-switch v-model="valuteInModal.isGet"></el-switch>
        </el-form-item>
        <el-form-item label="Предупреждение при продаже" class="long-label">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-model="valuteInModal.getWarn"
          ></el-input>
        </el-form-item>
      </div>
      <div class="inline-form-row">
        <el-form-item label="Мин. количество продажи" class="long-label">
          <el-input-number
            v-model="valuteInModal.minGive"
            title="Минимальное количество продажи"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="Макс. количество покупки за раз"
          class="long-label"
        >
          <el-input-number
            v-model="valuteInModal.maxGiveAtOnce"
            title="Максимальное количество покупки за раз"
          ></el-input-number>
        </el-form-item>
      </div>

      <el-tabs
        type="border-card"
        v-model="percentsActiveTab"
        editable
        @tab-add="handleAddCustomPercentClicked"
        @tab-remove="handleRemoveCustomPercentClicked"
        style="margin-bottom: 20px"
      >
        <el-tab-pane
          :closable="false"
          :key="'default'"
          :label="'По умолчанию'"
          :name="'default'"
        >
          <el-row :gutter="20">
            <el-col :span="12" :offset="0">
              <el-form-item label="Процент покупки">
                <el-input-number
                  v-model="valuteInModal.percentGive"
                  :min="0"
                  :max="100"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12" :offset="0">
              <el-form-item label="Процент продажи">
                <el-input-number
                  v-model="valuteInModal.percentGet"
                  :min="0"
                  :max="100"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane
          v-for="(item, index) in valuteInModal.customPercents"
          :key="item.name"
          :label="item.name"
          :name="item.name"
        >
          <el-row :gutter="20">
            <el-col :span="12" :offset="0">
              <el-form-item label="Процент покупки">
                <el-input-number
                  v-model="valuteInModal.customPercents[index].percentGive"
                  :min="0"
                  :max="100"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12" :offset="0">
              <el-form-item label="Процент продажи">
                <el-input-number
                  v-model="valuteInModal.customPercents[index].percentGet"
                  :min="0"
                  :max="100"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12" :offset="0">
              <el-form-item label="Покупаем">
                <el-switch
                  v-model="valuteInModal.customPercents[index].isGive"
                  :active-value="true"
                  :inactive-value="false"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12" :offset="0">
              <el-form-item label="Продаем">
                <el-switch
                  v-model="valuteInModal.customPercents[index].isGet"
                  :active-value="true"
                  :inactive-value="false"
                >
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div class="inline-form-row">
        <el-form-item label="Курс">
          <el-input-number v-model="valuteInModal.course"></el-input-number>
        </el-form-item>
        <el-form-item label="Минимальная комиссия" class="long-label">
          <el-input v-model="valuteInModal.minfee"
            ><template slot="prepend">$</template></el-input
          >
        </el-form-item>
      </div>
      <!--  -->
      <el-form-item v-if="isBanks" label="Принимать на Sbercore?">
        <el-switch v-model="valuteInModal.useSbercoreForDeposit"></el-switch>
      </el-form-item>
      <div
        class="inline-form-row"
        v-if="isBanks && valuteInModal.useSbercoreForDeposit"
      >
        <div>
          <el-form-item label="Банк для приема">
            <el-select
              v-model="valuteInModal.sbercoreDepositSiteAccount"
              value-key="value"
              filterable
            >
              <el-option
                v-for="item in sbercoreDepositSiteOptions"
                :key="item.value || 'any'"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-alert :title="'Внимание'" type="warning" :closable="false"
          >Прием на Sbercore в автоматическом режиме может работать нестабильно,
          рекомендуется добавить резервный кошелек для данной валюты.</el-alert
        >
      </div>
      <!--  -->
      <el-form-item label="Включить лимит">
        <el-switch v-model="valuteInModal.isLimit"></el-switch>
      </el-form-item>
      <!--  -->
      <div class="inline-form-row" v-if="valuteInModal.isLimit">
        <div>
          <el-form-item label="Лимит покупки">
            <el-input-number
              v-model="valuteInModal.limitPercentSell"
            ></el-input-number>
          </el-form-item>
          <p class="computed">{{ computedCourse.toFixed(5) }}</p>
        </div>
        <el-form-item label="Лимит продажи">
          <el-input-number
            v-model="valuteInModal.limitPercentBuy"
          ></el-input-number>
        </el-form-item>
        <div>
          <el-form-item label="Шаг в процентах">
            <el-input-number
              v-model="valuteInModal.step"
              :min="0"
              :max="100"
            ></el-input-number>
          </el-form-item>
          <p class="computed">{{ computedStep.toFixed(5) }}</p>
        </div>
        <el-form-item label="Место в топе">
          <el-input-number v-model="valuteInModal.limitPlace"></el-input-number>
        </el-form-item>
      </div>
      <!--  -->
      <el-form-item label="Фото валюты">
        <input
          accept="image/*"
          type="file"
          ref="inputFile"
          class="full-width-field"
          @change.prevent="
            $event => {
              valuteInModal.image = $event.target.files[0];
            }
          "
        />
      </el-form-item>
      <el-form-item
        v-if="isCrypto"
        label="Автопокупка на Whitebit"
        class="long-label"
      >
        <el-switch v-model="valuteInModal.useWhitebitWallet"></el-switch>
      </el-form-item>
      <el-form-item
        v-if="isBanks"
        label="Использовать кошелек с Firekassa"
        class="long-label"
      >
        <el-switch v-model="valuteInModal.withFirekassa"></el-switch>
      </el-form-item>
      <el-form-item
        v-if="isBanks && !isQiwi"
        label="Использовать инвойс Карта"
        class="long-label"
      >
        <el-switch v-model="valuteInModal.invoiceCard"></el-switch>
      </el-form-item>
      <el-form-item
        v-if="isQiwi"
        label="Использовать инвойс QIWI"
        class="long-label"
      >
        <el-switch v-model="valuteInModal.invoiceQw"></el-switch>
      </el-form-item>
      <el-form-item
        v-if="isYou"
        label="Использовать инвойс ЮMoney"
        class="long-label"
      >
        <el-switch v-model="valuteInModal.invoiceYou"></el-switch>
      </el-form-item>
      <div v-if="valuteInModal.useWhitebitWallet">
        <el-form-item label="Выберите ключ валюты" class="long-label">
          <el-select
            v-model="valuteInModal.rawKey"
            @change="valuteInModal.network = ''"
            :loading="!assetsLoaded"
            filterable
            clearable
            placeholder="Выберите ключ валюты"
          >
            <el-option
              v-for="item in assetsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <div class="input-error" v-if="!activeAsset && valuteInModal.rawKey">
          Валюта с данным ключом недоступна на Whitebit
        </div>
        <div class="input-error" v-if="!valuteInModal.rawKey">
          Нужно выбрать валюту с Whitebit!
        </div>

        <el-form-item
          v-if="activeAsset && availableValuteNetworks.length"
          label="Выберите сеть валюты"
          class="long-label"
        >
          <el-select
            v-if="activeAsset && availableValuteNetworks.length"
            v-model="valuteInModal.network"
            :loading="!assetsLoaded"
            filterable
            clearable
            placeholder="Выберите сеть валюты"
          >
            <el-option
              :key="-1"
              :value="-1"
              label="По умолчанию"
              selected
              disabled
            ></el-option>
            <el-option
              v-for="(item, i) in availableValuteNetworks"
              :key="i"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div
          class="input-error"
          v-if="availableValuteNetworks.length && !valuteInModal.network"
        >
          Нужно выбрать сеть для валюты!
        </div>
      </div>
    </el-form>

    <hr v-if="valuteInModal._id" class="hr" />

    <el-card class="box-card" v-if="valuteInModal._id">
      <div slot="header" class="clearfix">
        <span>Формы кошелька</span>
        <el-button
          v-if="!showValuteForm"
          style="float: right; padding: 3px 0"
          type="text"
          @click="SetValuteForm(-1, null)"
          >Добавить</el-button
        >
      </div>
      <el-form
        v-if="showValuteForm"
        ref="activeForm"
        :model="activeForm"
        label-width="100px"
        size="small"
      >
        <div class="inline-form-row">
          <el-form-item
            label="Название"
            prop="title"
            :rules="validation.form_title.rules"
          >
            <el-input v-model="activeForm.title"></el-input>
          </el-form-item>
          <el-form-item label="Подсказка">
            <el-input v-model="activeForm.placeholder"></el-input>
          </el-form-item>
          <el-form-item label="Ключ">
            <el-input v-model="activeForm.key"></el-input>
          </el-form-item>
          <el-form-item label="Поле обязательно" label-width="150px">
            <el-switch v-model="activeForm.required"></el-switch>
          </el-form-item>
          <el-form-item
            label="Шаг"
            prop="step"
            :rules="validation.form_step.rules"
          >
            <el-input-number
              v-model="activeForm.step"
              :min="1"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="Тип формы"
            prop="type"
            :rules="validation.form_type.rules"
            label-width="120px"
          >
            <el-select
              v-model="activeForm.type"
              placeholder="Выберите тип"
              clearable
            >
              <el-option
                v-for="item in activeFormType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-popconfirm
          title="Прекратить редактирование валютной формы?"
          @confirm="clearActiveForm"
        >
          <el-button slot="reference">Отмена</el-button>
        </el-popconfirm>

        <el-popconfirm title="Сохранить изменения?" @confirm="SubmitValuteForm">
          <el-button slot="reference" type="primary">Сохранить</el-button>
        </el-popconfirm>
        <hr class="hr" />
      </el-form>
      <div v-if="valuteFormsInModal && valuteFormsInModal.length">
        <ul class="valute-forms-list">
          <li v-for="(form, index) in valuteFormsInModal" :key="index">
            <el-popconfirm
              icon="el-icon-delete"
              icon-color="red"
              :title="`Удалить валютную форму '${form.title}'?`"
              @confirm="RemoveValuteForm(index, form)"
            >
              <i slot="reference" class="el-icon-delete delete"></i>
            </el-popconfirm>
            <i
              class="el-icon-edit edit"
              @click.prevent="SetValuteForm(index, form)"
            ></i>
            <span>{{ form.title }}</span>
          </li>
        </ul>
      </div>
      <p class="text-center" v-else>Список форм пуст.</p>
    </el-card>

    <span slot="footer" class="dialog-footer">
      <el-popconfirm
        title="Прекратить редактирование валюты?"
        @confirm="CancelEditValute"
      >
        <el-button slot="reference">Отмена</el-button>
      </el-popconfirm>

      <el-popconfirm title="Сохранить изменения?" @confirm="SubmitValute">
        <el-button slot="reference" type="primary">
          {{ valuteInModal._id ? "Редактировать валюту" : "Добавить валюту" }}
        </el-button>
      </el-popconfirm>
    </span>
    <el-dialog
      width="30%"
      title="Inner Dialog"
      :visible.sync="addNewCustomPercentDialogVisible"
      append-to-body
    >
      <el-form
        :model="newCustomPercent"
        label-width="100px"
        :inline="false"
        size="normal"
      >
        <el-form-item label="Сайт">
          <el-select v-model="newCustomPercent.name" filterable>
            <el-option
              v-for="item in filteredSites"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Процент покупки">
          <el-input-number
            v-model="newCustomPercent.percentGive"
            :min="0"
            :max="100"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="Процент продажи">
          <el-input-number
            v-model="newCustomPercent.percentGet"
            :min="0"
            :max="100"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="Покупаем">
          <el-switch
            v-model="newCustomPercent.isGive"
            :active-value="true"
            :inactive-value="false"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="Продаем">
          <el-switch
            v-model="newCustomPercent.isGet"
            :active-value="true"
            :inactive-value="false"
          >
          </el-switch>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onAddNewCustomPercent"
            >Добавить</el-button
          >
          <el-button @click="addNewCustomPercentDialogVisible = false"
            >Отмена</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-dialog>
</template>

<script>
//
const defaultFormData = {
  _id: false,
  isCash: false,
  title: "",
  description: "",
  type: null,
  step: 1,
  required: true
};
const defaultNewCustomPercent = {
  name: "",
  percentGive: 0.95,
  percentGet: 1.05,
  isGet: false, //продаем
  isGive: false //покупаем
};
//
import { mapActions, mapState } from "vuex";
import validation from "../../validation";
import { getWhitebitAssets } from "@/api";
//
export default {
  name: "EditValuteComponent",
  props: ["modal"],
  //
  data() {
    return {
      showValuteForm: false,
      addNewCustomPercentDialogVisible: false,
      activeFormIndex: -1,
      assetsOptions: [],
      assetsLoaded: false,
      activeForm: { ...defaultFormData },
      validation,
      newCustomPercent: { ...defaultNewCustomPercent },
      percentsActiveTab: "default",
      activeFormType: [
        { label: "Покупка", value: 0 },
        { label: "Продажа", value: 1 }
      ],
      sbercoreDepositSiteOptions: [
        {
          label: "Любой",
          value: null
        },
        {
          label: "Сбер",
          value: "sber"
        },
        {
          label: "Тинькофф",
          value: "tinkoff"
        }
      ]
    };
  },
  //
  computed: {
    ...mapState("auth", ["session"]),
    ...mapState("valutes", [
      "valutes",
      "sites",
      "valutesForms",
      "categories",
      "isFiltered",
      "valuteInModal",
      "valuteFormsInModal",
      "dialogVisible"
    ]),
    filteredSites: function() {
      return this.sites.filter(site => {
        return !this.valuteInModal.customPercents
          .map(perc => perc.name)
          .includes(site);
      });
    },
    computedDialogVisible: {
      get() {
        console.log(1);
        return this.dialogVisible;
      },
      set(val) {
        this.changeDialogVisible({ dialogVisible: val });
      }
    },
    computedStep: function() {
      return (this.valuteInModal.course / 100) * this.valuteInModal.step;
    },
    computedCourse: function() {
      return this.valuteInModal.course * this.valuteInModal.limitPercentSell;
    },
    isCrypto() {
      const category = this.categories.find(
        cat => cat.key == this.valuteInModal.categories[0]
      );
      return category && category.key == "crypto";
    },
    isBanks() {
      const category = this.categories.find(
        cat => cat.key == this.valuteInModal.categories[0]
      );
      return category && category.key == "bank";
    },
    isQiwi() {
      return this.valuteInModal.title === "QIWI";
    },
    isYou() {
      return this.valuteInModal.bestchangeKey === "YAMRUB";
    },
    activeAsset() {
      return this.assets && this.assets[this.valuteInModal.rawKey]
        ? this.assets[this.valuteInModal.rawKey]
        : null;
    },
    availableValuteNetworks() {
      return this.activeAsset && this.activeAsset.networks
        ? this.activeAsset.networks.deposits
        : [];
    }
  },
  //
  methods: {
    ...mapActions("valutes", [
      "addValute",
      "editValute",
      "addValuteForm",
      "editValuteForm",
      "changeDataInModal",
      "deleteValuteForm",
      "changeDialogVisible"
    ]),
    onAddNewCustomPercent() {
      if (
        !this.newCustomPercent.name ||
        !this.newCustomPercent.percentGive ||
        !this.newCustomPercent.percentGet
      )
        return;
      this.valuteInModal.customPercents = [
        ...this.valuteInModal.customPercents,
        { ...this.newCustomPercent }
      ];
      this.addNewCustomPercentDialogVisible = false;
      this.newCustomPercent = { ...defaultNewCustomPercent };
    },

    handleAddCustomPercentClicked() {
      if (!this.filteredSites.length) return;
      this.addNewCustomPercentDialogVisible = true;
    },

    handleRemoveCustomPercentClicked(name) {
      if (name === "default") return;
      this.valuteInModal.customPercents = [
        ...this.valuteInModal.customPercents.filter(perc => perc.name !== name)
      ];
      this.percentsActiveTab = "default";
    },

    clearActiveForm() {
      this.showValuteForm = false;
      this.activeFormIndex = -1;
      this.percentsActiveTab = "default";

      if (typeof this.$refs["activeForm"] !== "undefined") {
        this.$refs["activeForm"].resetFields();
        this.$refs["activeForm"].clearValidate();
      }
    },

    SetValuteForm(index, form = null) {
      this.activeFormIndex = index;
      this.activeForm = { ...(form ? form : defaultFormData) };
      console.log(index, form);
      if (typeof this.$refs["activeForm"] !== "undefined") {
        this.$refs["activeForm"].clearValidate();
      }

      this.showValuteForm = true;
    },

    CancelEditValuteWithConfirm() {
      this.$confirm("Прекратить редактирование валюты?", "", {
        confirmButtonText: "Да",
        cancelButtonText: "Нет"
      })
        .then(_ => {
          this.CancelEditValute();
        })
        .catch(_ => {});
    },

    CancelEditValute() {
      this.$refs["inputFile"].value = null;
      this.changeDialogVisible({ dialogVisible: false });
      this.changeDataInModal({});
      this.clearActiveForm();
    },

    RemoveValuteForm(index, form) {
      if (form._id) {
        this.deleteValuteForm({
          valuteId: this.valuteInModal._id,
          formId: form._id
        }).then(res => {
          this.$message.success("Вы успешно удалили форму!");
          this.valuteFormsInModal.splice(index, 1);
        });
      }
    },

    SubmitValute() {
      this.$refs["valuteInModal"].validate(async valid => {
        if (valid) {
          const valute = this.valuteInModal;
          //
          if (valute._id) {
            this.selectedValuteCities = this.valuteInModal.valuteCities;
            let editValute = {
              ...valute,
              categories: JSON.stringify(valute.categories)
            };
            //
            console.log("editValute = ", editValute);
            this.editValute({ id: valute._id, valute: editValute }).then(() => {
              this.$nextTick().then(() =>
                this.$message.success("Операция прошла успешно")
              );
              this.valuteInModal.image = false;
              this.CancelEditValute();
            });
          } else {
            let addValute = {
              ...valute,
              categories: JSON.stringify(valute.categories),
              customPercents: JSON.stringify(valute.customPercents)
            };
            //
            this.addValute(addValute).then(() => {
              this.$nextTick().then(() =>
                this.$message.success("Операция прошла успешно")
              );
              this.valuteInModal.image = false;
              this.CancelEditValute();
            });
          }
        } else {
          this.$message({
            type: "error",
            message: "Ошибка при заполнении формы!"
          });
        }
      });
    },

    SubmitValuteForm() {
      this.$refs["activeForm"].validate(async valid => {
        if (valid) {
          if (this.activeFormIndex < 0) {
            // add
            this.addValuteForm({
              valuteId: this.valuteInModal._id,
              formData: this.activeForm
            }).then(response => {
              console.log("response = ", response);
              this.valuteFormsInModal.push(response.data.result);
              this.$message.success("Вы успешно добавили форму валюты");
              this.clearActiveForm();
            });
          } else {
            // save edit
            this.editValuteForm({
              valuteId: this.valuteInModal._id,
              formId: this.activeForm._id,
              formData: this.activeForm
            }).then(response => {
              this.valuteFormsInModal[this.activeFormIndex] =
                response.data.result;
              this.$message.success("Вы успешно изменили форму валюты");
              this.clearActiveForm();
            });
          }
        } else {
          this.$message({
            type: "error",
            message: "Ошибка при заполнении формы!"
          });
        }
      });
    }
  },

  async mounted() {
    getWhitebitAssets()
      .then(res => {
        this.assets = res.data;
        this.assetsOptions = Object.entries(this.assets).map(e => {
          return {
            value: e[0],
            label: e[0]
          };
        });
        this.assetsLoaded = true;
      })
      .catch(e => {
        console.error(e);
      });
  }
};
</script>

<style scoped>
.el-dialog__wrapper >>> .valute-dialog {
  width: 60%;
  min-width: 420px;
}

.el-dialog__wrapper >>> .valute-dialog .el-dialog__body {
  padding-bottom: 0;
}

.long-label >>> .el-form-item__label {
  line-height: 1.5;
  word-break: break-word;
}

.delete {
  color: red;
  float: right;
}

.edit {
  color: orange;
  float: right;
  margin-right: 5px;
}

.delete,
.edit {
  cursor: pointer;
}

label {
  display: block;
}

.valute-forms input {
  display: block;
  max-width: 92%;
}

.content__label {
  margin-top: 15px;
  margin-bottom: 5px;
}

.input-error {
  font-size: 12px;
  color: #f22;
  margin-left: 150px;
  margin-top: -15px;
}

.text-center {
  text-align: center;
}

.hr {
  border-top: 1px solid #ebeef5;
  margin: 1em 0;
}

.box-card {
  margin-top: 30px;
}

.valute-forms-list {
  padding-left: 20px;
}

.valute-forms-list li {
  margin-bottom: 10px;
}

.valute-forms-list li:last-child {
  margin-bottom: 0;
}

.title-margin {
  margin-bottom: 1.5em;
  margin-top: 1.5em;
}

.computed {
  margin-left: 150px;
  margin-bottom: 20px;
}

.full-width-field {
  width: 100%;
  box-sizing: border-box;
}

@media (min-width: 1200px) {
  .inline-form-row >>> .el-form-item,
  .inline-form-row > div {
    display: inline-block;
    padding: 0 10px;
    vertical-align: top;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Valutes/components/EditValute/index.vue